<template>
  <v-card v-if="ready" class="elevation-0">
    <v-card-text class="pa-1">
      <treemap-chart
        :data="chartData"
        :colors="colors"
        title="Appointment Status Counts"></treemap-chart>
    </v-card-text>
  </v-card>
  <v-skeleton-loader v-else class="mx-auto" type="card"></v-skeleton-loader>
</template>

<script>
import insightsMixin from '@/components/mixins/insightsMixin';
import { globalThemeColors as statusColors } from '@/plugins/vuetifyPlugin';

/**
 * Appointments Statuses Treemap Chart
 * @displayName Appointments Statuses Treemap Chart
 */
export default {
  mixins: [insightsMixin],
  data() {
    return {
      queryParams: [
        `status {
             Scheduled
             Arrived
             Completed
             NoShow
             Cancelled
            }`
      ],
      dataKey: 'status',
      colors: [],
      statusMap: {
        Scheduled: {},
        Arrived: {},
        Completed: {},
        NoShow: {},
        Cancelled: {}
      }
    };
  },
  methods: {
    /**
     * Format chart data
     * @public
     */
    formatData() {
      this.chartData = [];

      for (let status in this.statusMap) {
        if (this.appointmentVolume.status[status] && this.appointmentVolume.status[status] > 0) {
          this.chartData.push({
            x: this.novaCore.AppointmentStatus[status],
            y: this.appointmentVolume.status[status]
          });
          this.colors.push(statusColors[status.toLowerCase()].base);
        }
      }
      this.ready = true;
    }
  }
};
</script>
